import React, { Component } from "react";

import ReactGA from "react-ga4";

const withTracker = (WrappedComponent, options = {}) => {
	const trackPage = page => {
		if (localStorage.getItem("enableGoogleAnalytics") === "true") {
			ReactGA.initialize(localStorage.getItem("googleAnalyticsId"));
			ReactGA.set({
				page,
				...options
			});
			ReactGA.send({ hitType: "pageview", page: page});
		}
	};

	const HOC = class extends Component {
		componentDidMount() {
			const page = this.props.location?.pathname;
			trackPage(page);
		}

		UNSAFE_componentWillReceiveProps(nextProps) {
			if (this.props.location != nextProps.location) {
				const currentPage = this.props.location.pathname;
				const nextPage = nextProps.location.pathname;

				if (currentPage !== nextPage) {
					trackPage(nextPage);
				}
			}	
		}

		render() {
			return <WrappedComponent {...this.props} />;
		}
	};

	return HOC;
};

export default withTracker;
